// Cluster + incentive configuration lives in the shared `config` collection
// (config/clusters, config/incentives). The published Firestore rules already
// allow `config` read for any signed-in user and write for admins — so this
// persists to the real Firebase project without needing a rules deploy.
import { adapter } from "./db";

const now = () => new Date().toISOString();

export const DEFAULT_INCENTIVE = {
  per_completed_job: 0,
  per_brugo_promise: 0,
  response_rate_target: 80,
  response_rate_bonus: 0,
  top_pro_cluster_bonus: 0,
  max_promise_cluster_bonus: 0,
  cluster_lead_bonus: 0,
};

export const saveClusters = (list) =>
  adapter.set("config", "clusters", { list, updated_at: now() });

export const saveIncentives = (rules) =>
  adapter.set("config", "incentives", { rules, updated_at: now() });
